import { NavLink, useNavigate } from "react-router-dom";
import { ModeToggle } from "./style/mode-toggle";

import { Paths } from "./constants/Paths";
import { useAuth } from "./provider/AuthProvider";
import { Button } from "@/components/ui/button";
import ProfileTop from "./components/ProfileTop";
import { useDispatch } from "react-redux";

export function MainNavigations(userDetail) {
  const { token, setToken } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <header>
      <nav className=" shadow">
        <div className="container mx-auto px-4 flex flex-wrap items-center justify-between py-3 space-x-3 ">
          <a
            href={Paths.HOME}
          >
            <img
              alt="Yatra Tickets Logo"
              className="max-w-40 w-40 lg:max-w-45 h-auto"
              src={'/images/yatraTicketsLogo.jpg'}
            />

          </a>
          <div
            className="flex-1 flex-nowrap items-center justify-end w-full md:flex md:w-auto md:order-1 flex space-x-2"
            id="navbar-user"
          >
            <div className="space-x-4 hidden md:flex me-2">
              <a
                className="font-medium text-foreground/60 transition-colors hover:text-foreground/80 lg:block text-sm"
                href={Paths.HOME}
              >
                Home
              </a>
              <a
                className="font-medium text-foreground/60 transition-colors hover:text-foreground/80 lg:block text-sm"
                href={Paths.ABOUT_US}

              >
                About Us
              </a>
              <a
                className="font-medium text-foreground/60 transition-colors hover:text-foreground/80 lg:block text-sm"
                href={Paths.CONTACT_US}

              >
                Contact Us
              </a>
              <a
                className="font-medium text-foreground/60 transition-colors hover:text-foreground/80 lg:block text-sm"
                href={"/profile"}
              >
                {userDetail && userDetail.UserName}
              </a>
            </div>
            <div className="space-x-3  justify-end flex">
              {token ? (
                <ProfileTop />
              ) : (
                <>
                  <div className="space-x-2 flex-nowrap flex">
                    <Button
                      variant="outline"
                      className="px-2 lg:px-4"
                      //onClick={() => navigate("/auth/login")}
                      onClick={() => navigate(`/auth/login?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`)}
                    >
                      Login
                    </Button>
                    <Button className="px-2 lg:px-4" onClick={() => navigate(`/auth/register?returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`)}>
                      Register
                    </Button>
                  </div>
                  <ModeToggle />
                </>
              )}
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
